exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-block-news h2[data-v-950da7d2]{letter-spacing:normal}#tSkuFieldSett tr.smooth-dnd-draggable-wrapper[data-v-950da7d2]{display:table-row}#tSkuFieldSett .smooth-dnd-ghost[data-v-950da7d2]{display:table-row!important}#tSkuFieldSett .smooth-dnd-ghost>td[data-v-950da7d2]:first-child{width:100%}.result-import[data-v-950da7d2]{letter-spacing:0;background:#fff}.panel-body-actions-false[data-v-950da7d2]{border-top:none;height:62px}.panel-body-actions-footer[data-v-950da7d2]{position:absolute;bottom:0;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-950da7d2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/Sku.vue
// module id = 814
// module chunks = 1